import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const defaultSlides = [
  { image: "https://images.unsplash.com/photo-1763405739542-02991ab5416c?w=1920&q=80", title: "Geleceği\nİnşa Ediyoruz", subtitle: "25 yılı aşkın deneyimle Türkiye'nin dört bir yanında modern yapılar" },
  { image: "https://images.pexels.com/photos/1402923/pexels-photo-1402923.jpeg?auto=compress&cs=tinysrgb&w=1920", title: "Kalite ve\nGüven", subtitle: "Her projede mükemmellik standartları, zamanında teslimat" },
  { image: "https://images.unsplash.com/photo-1758448501014-3a6068fb9d51?w=1920&q=80", title: "Modern\nYaşam Alanları", subtitle: "Sürdürülebilir, yenilikçi ve konforlu konut projeleri" },
];

export default function HeroSlider() {
  const [slides, setSlides] = useState(defaultSlides);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    axios.get(`${API}/api/slides`).then((r) => {
      if (r.data.length > 0) setSlides(r.data);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setCurrent((p) => (p + 1) % slides.length), 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section id="anasayfa" data-testid="hero-slider" className="hero-section">
      {slides.map((s, i) => (
        <div key={i} className={`hero-bg ${current === i ? "active opacity-100" : "opacity-0"}`} style={{ backgroundImage: `url(${s.image})` }} />
      ))}
      <div className="hero-gradient" />
      <div className="relative z-10 h-full flex flex-col justify-end pb-16 sm:pb-24 px-5 sm:px-8 lg:px-12 max-w-7xl mx-auto">
        <AnimatePresence mode="wait">
          <motion.div key={current} initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -30 }} transition={{ duration: 0.7, ease: "easeOut" }} className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] tracking-tighter mb-5 whitespace-pre-line" style={{ fontFamily: "Outfit" }}>
              {slides[current].title}
            </h1>
            <p className="text-base sm:text-lg text-white/70 max-w-lg mb-8 leading-relaxed">{slides[current].subtitle}</p>
            <div className="flex flex-wrap gap-4">
              <a href="#projeler" className="btn-modern btn-filled">Projelerimiz <ArrowRight size={16} /></a>
              <a href="#iletisim" className="btn-modern btn-outline">İletişim</a>
            </div>
          </motion.div>
        </AnimatePresence>
        <div className="flex items-center gap-3 mt-12">
          {slides.map((_, i) => (
            <button key={i} data-testid={`hero-dot-${i}`} onClick={() => setCurrent(i)} className={`h-1 rounded-full transition-all duration-500 ${current === i ? "w-12 bg-[#FF5A00]" : "w-6 bg-white/30 hover:bg-white/50"}`} />
          ))}
          <span className="ml-4 text-sm text-white/40 font-medium" style={{ fontFamily: "Outfit" }}>
            {String(current + 1).padStart(2, "0")} / {String(slides.length).padStart(2, "0")}
          </span>
        </div>
      </div>
    </section>
  );
}
